import { useConfiguration } from './configuration.queries';

/**
 * @deprecated Use useConfiguration instead.
 */
export const useSuspenseConfiguration = () => {
  return useConfiguration();
};
